import _ from 'lodash'
import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import {
  API_PREFIX, LOGIN_URL,
} from '@/utils/constants'

const service = axios.create({
  withCredentials: true,
  timeout: 15000,
})

const duration = 3 * 1000

const whiteList = [
  `${API_PREFIX}/api/v1.Login/login`,
  `${API_PREFIX}/api/v1.Register/register`,
  `${API_PREFIX}/api/v1.Sms/sendSms`,
  `${API_PREFIX}/api/v1.Project/projectTypeList`,
  `${API_PREFIX}/api/v1.Project/addProject`,
  `${API_PREFIX}/api/v1.Login/loginByMobile`,
  `${API_PREFIX}/api/v1.Login/forgetPwd`,
  `${API_PREFIX}/api/v1.Register/checkUserNameIsExist`,
  `${API_PREFIX}/api/v1.User/getUserInfo`,
]
/* eslint-disable no-param-reassign */
service.interceptors.request.use((config) => {
  if (whiteList.some(url => config.url.indexOf(url) >= 0)) {
    return config
  }
  if (!_.isEmpty(store.state.userInfo) && store.state.userInfo.belong) {
    config.headers.belong = store.state.userInfo.belong
    return config
  }
  const redirectUrl = encodeURIComponent(window.location.href)
  window.location.href = `${LOGIN_URL}?url=${redirectUrl}`
  return false
}, (err) => {
  Message({
    type: 'error',
    message: '请求发送失败',
    duration: 5 * 1000,
  })
  return Promise.reject(err)
})

service.interceptors.response.use((response) => {
  const res = response.data
  const code = +res.status || +res.code
  const msg = res.statusInfo || res.msg || res.errMsg
  if (code === 401 && (msg === '未登录' || msg === '用户不存在!' || msg === '登录失效')) {
    const redirectUrl = encodeURIComponent(window.location.href)
    window.location.href = `${LOGIN_URL}?url=${redirectUrl}`
    return Promise.resolve(false)
  } if (code < 200 || code >= 400) {
    Message({
      message: msg,
      type: 'error',
      duration,
    })
    return Promise.reject(res)
  }
  return Promise.resolve(res)
}, (err) => {
  const data = err.response.data
  Message({
    message: err.statusInfo || err.msg || data.msg,
    type: 'error',
    duration: 5 * 1000,
  })
  return Promise.reject(err)
})

export default service
